import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFieldset } from 'src/shared/components/form/formFieldset';
import { StyledToggleButtonGroup } from 'src/shared/components/organisms/styledToggleButtonGroup';
import { Box, ToggleButton } from '@mui/material';
import SearchField from 'src/shared/components/form/searchField';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { EventTicket } from '../models/eventTicket';
import { EventParticipantTicketSearchFilter } from '../models/eventParticipantTicketSearchFilter';

type EventTicketsDataGridFilterProps = {
  tickets: Array<EventTicket>;
  searchFilter: EventParticipantTicketSearchFilter;
  setSearchFilter: Dispatch<SetStateAction<EventParticipantTicketSearchFilter>>;
};

export const EventTicketsDataGridFilter = (props: EventTicketsDataGridFilterProps) => {
  const { tickets, searchFilter, setSearchFilter } = props;
  const { t } = useTranslation();
  const isMounted = useIsMounted();

  const [tempSearchString, setTempSearchString] = useState<string | undefined>(undefined);
  const [searchInitialized, setSearchInitialized] = useState<boolean>(false);

  const handleKeys = (_event: React.MouseEvent<HTMLElement>, newKeys: Array<EventTicket>) => {
    if (!newKeys || newKeys.length === 0) return;
    setSearchFilter((prev) => ({ ...prev, ...{ selectedTicketTypes: newKeys } }));
  };

  useEffect(() => {
    if (isMounted() && searchInitialized) {
      if (tempSearchString === '') {
        setSearchFilter((prev) => ({ ...prev, ...{ searchString: '' } }));
      }
      if (tempSearchString && tempSearchString.length >= 2) {
        setSearchFilter((prev) => ({ ...prev, ...{ searchString: tempSearchString } }));
      } else {
        setSearchFilter((prev) => ({ ...prev, ...{ searchString: '' } }));
      }
    }
  }, [isMounted, searchInitialized, setSearchFilter, setTempSearchString, tempSearchString]);

  return (
    <Box display='flex' alignItems='center' flexWrap='wrap' gap={2}>
      <Box>
        <SearchField
          initialValue={searchFilter.searchString || ''}
          onSearch={(newSearchString) => {
            setSearchInitialized(true);
            setTempSearchString(newSearchString);
          }}
        />
      </Box>
      <Box>
        <FormFieldset legend={t('event:ticketType')} noPadding displayInline>
          <StyledToggleButtonGroup value={searchFilter.selectedTicketTypes} onChange={handleKeys} color='primary' size='small'>
            {tickets &&
              tickets.map((ticketType) => (
                <ToggleButton value={ticketType} key={ticketType.id}>
                  {ticketType.ticketName}
                </ToggleButton>
              ))}
          </StyledToggleButtonGroup>
        </FormFieldset>
      </Box>
    </Box>
  );
};
